module.exports = __webpack_public_path__ + "img/tarjeta_bg_logo.9608dc5.svg";